<h1 mat-dialog-title>
    {{title}}
  </h1>
  
  <div mat-dialog-content>
    <p>{{'Dialog.Message' | translate}}</p>
  </div>
  
  <div mat-dialog-actions>
    <button mat-button (click)="onDismiss()">{{ 'Dialog.No' | translate }}</button>
    <button mat-raised-button (click)="onConfirm()">{{ 'Dialog.Yes' | translate }}</button>
  </div>